import React, { useEffect, useRef } from 'react';
import './World.css';

const World = () => {
  const sectionRef = useRef(null);
  const titleContainerRef = useRef(null);
  const narrativeCardRef = useRef(null);
  const squareRef = useRef(null);

  useEffect(() => {
    // New effect to trigger fade-in on the title container
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && titleContainerRef.current) {
          titleContainerRef.current.classList.add('active');
        }
      },
      { threshold: 0.99 }
    );
    if (titleContainerRef.current) observer.observe(titleContainerRef.current);

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    // New intersection observer for narrative card
    const cardObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && narrativeCardRef.current) {
          narrativeCardRef.current.classList.add('active');
        }
      },
      { threshold: 0.55}
    );
    if (narrativeCardRef.current) cardObserver.observe(narrativeCardRef.current);

    return () => cardObserver.disconnect();
  }, []);

  useEffect(() => {
    // New observer for the blue square
    const squareObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          sectionRef.current.querySelector('.blue-line-vertical')?.classList.add('active');
          document.querySelector('.blue-line-horizontal')?.classList.add('active');
        }
      },
      { threshold: 0.5 }
    );

    if (squareRef.current) squareObserver.observe(squareRef.current);

    return () => squareObserver.disconnect();
  }, []);

  return (
    <div className="world-page-container" ref={sectionRef}>
      <div className="world-gradient-right"></div>
      <div className="world-gradient-left"></div>
      <div className="content-section">
        <div className="blue-line-vertical"></div>
        <div className="title-container" ref={titleContainerRef}>
          <h1 className="title-font">Welcome Pilot.<span className="cursor">|</span></h1>
          <div ref={squareRef} className="blue-square"></div>
          <div className="digital-lines"></div>
        </div>
        <div className="narrative-card" ref={narrativeCardRef}>
          <p className="narrative-text">
            Nearly the entire population of Burrow 11 rests in stasis, but a few high performing 
            individuals remain alert and sealed away in their own rooms. Due to the potential risks 
            that isolation can bring, the Management AI has done its best to strip away all worries, 
            fears and emotions for these pilots.</p>

          <p className="narrative-text">
            To the pilots the world feels distant, only allowed to touch it through the veil of 
            glowing screens and the metallic husks of the drones. It's the closest taste of the 
            real world for the pilots. For better or for worse, through journeys in the city, 
            the pilots will remember what it is to be alive.
          </p>
          <p className="narrative-text">The world is in ruins, Salvage yourself.</p>
        </div>
        <div className="blue-line-horizontal"></div>
      </div>
    </div>
  );
};export default World;